

























import { Component, Vue, Watch } from 'vue-property-decorator'
import { RouteRecord, Route } from 'vue-router'

@Component({})
export default class TagsView extends Vue {
  private breadcrumbs: RouteRecord[] = []
  private tags: any[] = []
  private top: number = 0
  private left: number = 0
  private visible: boolean = false
  created() {
    this.tags = [...this.tags, this.$route]
  }
  @Watch('$route')
  private isActive(route: string) {
    return route === this.$route.path
  }
  @Watch('$route')
  private getTags() {
    let bool = false
    this.tags.forEach(item => {
      // @ts-ignore
      if (this.$route.path === item['path']) {
        bool = true
      }
    })
    if (!bool) {
      this.tags = [...this.tags, this.$route]
    }
    // console.log(this.tags)
  }
  @Watch('visible')
  private onVisibleChange(value: boolean) {
    if (value) {
      document.body.addEventListener('click', this.closeMenu)
    } else {
      document.body.removeEventListener('click', this.closeMenu)
    }
  }
  private closeMenu() {
    this.visible = false
  }
  private onRouteChange(route: Route) {
    // if you go to the redirect page, do not update the breadcrumbs
    if (route.path.startsWith('/redirect/')) {
      return
    }
  }
  private closeTags(d: any, event: any) {
    if (event) event.preventDefault()
    this.tags = this.tags.filter(item => item !== d)
    const latestView = this.tags.slice(-1)[0]
    if (latestView) {
      this.$router.push(latestView)
    } else {
      this.$router.push('/')
    }
  }
  private closeOthersTags() {}
  private openMenu(tag: string, e: MouseEvent) {
    const menuMinWidth = 105
    const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
    const offsetWidth = (this.$el as HTMLElement).offsetWidth // container width
    const maxLeft = offsetWidth - menuMinWidth // left boundary
    const left = e.clientX - offsetLeft + 145 // 15: margin right
    if (left > maxLeft) {
      this.left = maxLeft
    } else {
      this.left = left
    }
    this.top = e.clientY + 10
    this.visible = true
    // this.selectedTag = tag
  }
}
